// frontend/src/theme/plugins/plum-theme.js
export const plumTheme = {
  // Brand color: #9a3f69 (Plum)
  palette: {
    primary: {
      lighter: '#E7D6E0',
      light: '#C87DA1',
      main: '#9A3F69',
      dark: '#702C4D',
      darker: '#4A1C33',
      contrastText: '#FFFFFF',
    },
    secondary: {
      lighter: '#F6EDD0',
      light: '#E7C87B',
      main: '#DAA03D', // Using gold as secondary
      dark: '#B5842F',
      darker: '#78561F',
      contrastText: '#000000',
    },
    success: {
      lighter: '#D8F7E3',
      light: '#6AD89C',
      main: '#2EB669',
      dark: '#208D51',
      darker: '#136643',
      contrastText: '#FFFFFF',
    },
    info: {
      lighter: '#D1E9FC',
      light: '#76B0F1',
      main: '#2196F3',
      dark: '#0E5593',
      darker: '#04297A',
      contrastText: '#FFFFFF',
    },
    warning: {
      lighter: '#FFF7CD',
      light: '#FFE16A',
      main: '#FFC107',
      dark: '#B78103',
      darker: '#7A4F01',
      contrastText: '#000000',
    },
    error: {
      lighter: '#FFE7D9',
      light: '#FFA48D',
      main: '#FF4842',
      dark: '#B72136',
      darker: '#7A0C2E',
      contrastText: '#FFFFFF',
    },
    grey: {
      100: '#F9FAFB',
      200: '#F4F6F8',
      300: '#DFE3E8',
      400: '#C4CDD5',
      500: '#919EAB',
      600: '#637381',
      700: '#454F5B',
      800: '#212B36',
      900: '#161C24',
    },
  },
  
  // Custom shadows
  customShadows: {
    card: '0 2px 12px 0 rgba(154, 63, 105, 0.08)',
    dropdown: '0 4px 16px 0 rgba(154, 63, 105, 0.12)',
    button: '0 2px 6px 0 rgba(154, 63, 105, 0.25)',
    dialog: '0 8px 24px 0 rgba(154, 63, 105, 0.16)',
    primary: '0 8px 16px 0 rgba(154, 63, 105, 0.24)',
  },
  
  // Custom background gradients
  gradients: {
    primary: 'linear-gradient(135deg, #9A3F69 0%, #B15483 100%)',
    secondary: 'linear-gradient(135deg, #DAA03D 0%, #E5BA6D 100%)',
    info: 'linear-gradient(135deg, #2196F3 0%, #64B6F7 100%)',
    success: 'linear-gradient(135deg, #2EB669 0%, #5ACD8C 100%)',
    warning: 'linear-gradient(135deg, #FFC107 0%, #FFD54F 100%)',
    error: 'linear-gradient(135deg, #FF4842 0%, #FF7D71 100%)',
    dark: 'linear-gradient(135deg, #404040 0%, #656565 100%)',
  },

  // ── Theme metadata for theme.caro (spec 20260930-caro-editorial-theme, T028) ─────────────
  // Additive only: no key above changes, so the rendered plum theme stays identical.
  // Navigation sidebar keeps today's glass look; create-theme.js fills in the glass per mode.
  sidebar: { solid: false },
  // Status pairs derived from this palette (lighter / darker / light of each colour).
  status: {
    available: { bg: '#D8F7E3', fg: '#136643', border: '#6AD89C' },
    rollout: { bg: '#FFF7CD', fg: '#7A4F01', border: '#FFE16A' },
    urgent: { bg: '#FFE7D9', fg: '#7A0C2E', border: '#FFA48D' },
    brand: { bg: '#E7D6E0', fg: '#4A1C33', border: '#C87DA1' },
    neutral: { bg: '#F4F6F8', fg: '#212B36', border: '#DFE3E8' },
  },
  // Phase 4b parks replaced literals here so plum keeps its exact look.
  legacy: {},
};